module.exports = __webpack_public_path__ + "static/media/roof_closeup.8e8e3a09.png";